import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { usePostHog } from "posthog-js/react";

const LogoutPage = () => {
  const { logout } = useAuth0();
  const posthog = usePostHog()

  useEffect(() => {
    posthog?.capture('clicked_log_out')
  }, [posthog])

  posthog?.reset()
  logout({ logoutParams: { returnTo: window.location.origin } })

  return (<div></div>)
};

export default LogoutPage;